import { useEffect, useState } from "react";

const useAdjustCalendarSize = (
    calendarRef: React.RefObject<HTMLDivElement>,
    isTopNavbarEnabled: boolean,
    timeSlots: string[] | undefined,
) => {
    const [pixelsPerMinute, setPixelsPerMinute] = useState<number | undefined>(undefined);

    useEffect(() => {
        const calculateSizing = () => {
            // Return if no calendar ref current is known
            if (!calendarRef.current || !timeSlots?.length) return;

            const calendar = calendarRef.current;

            // Get the height of the window of the user
            const windowHeight = window.innerHeight;

            // If the top navbar is enabled, get its height
            let topNavbarHeight = 0;
            if (isTopNavbarEnabled) {
                const topNavbar = document.querySelector('.topbar') as HTMLElement;
                topNavbarHeight = topNavbar ? topNavbar.offsetHeight : 0;
            }

            // Get the navbar height
            const navBar = document.querySelector('.navbar') as HTMLElement;
            const subNavBar = document.querySelector('.subnavbar') as HTMLElement;
            const navBarHeight = navBar ? navBar.offsetHeight : 0;
            const subNavBarHeight = subNavBar ? subNavBar.offsetHeight : 0;

            // Get the height of the page header and scheduling header
            const navBarWrapper = document.querySelector('.navbar-wrapper') as HTMLElement;
            const navBarWrapperMarginBottom = document.querySelector('.navbar-wrapper') ? parseInt(window.getComputedStyle(navBarWrapper).marginBottom) : 0;
            const pageHeader = document.querySelector('.scheduling-header') as HTMLElement;
            const pageHeaderMarginBottom = pageHeader ? parseInt(window.getComputedStyle(pageHeader).marginBottom) : 0;

            // Calculate the height of the page header
            const pageHeaderHeight = pageHeader ? pageHeader.offsetHeight + pageHeaderMarginBottom : 0;

            // Calculate the height of the area above the scheduler component
            const heightAboveScheduler = topNavbarHeight + navBarHeight + subNavBarHeight + navBarWrapperMarginBottom + pageHeaderHeight;
    
            // Get the height of the calendar header and the to schedule row
            const boardHeader = document.querySelector('.personal-calendar .header') as HTMLElement;
            const boardHeaderHeight = boardHeader ? boardHeader.offsetHeight : 0;

            // Calculate the height above the calendar body
            const totalOffset = heightAboveScheduler + boardHeaderHeight;

            // Calculate the height available for the calendar body
            const availableHeight = windowHeight - totalOffset;

            // Apply the height to the calendar body
            const body = calendar.querySelector('.calendar-body') as HTMLElement;
            if (body) {
                body.style.height = `${availableHeight}px`;
            }

            // Calculate the pixels per minute
            const minutesPerDay = timeSlots.length * 30;
            const ppm = availableHeight / minutesPerDay;

            // Set the pixels per minute
            setPixelsPerMinute(ppm);
        };

        calculateSizing();

        window.addEventListener('resize', calculateSizing);

        // Resize with the nav chrome too, the sub navbar and the notification banner live
        // inside the navbar wrapper and change the height available to the calendar
        const navBarWrapper = document.querySelector('.navbar-wrapper');
        const navBarResizeObserver = navBarWrapper ? new ResizeObserver(calculateSizing) : null;
        if (navBarWrapper && navBarResizeObserver) {
            navBarResizeObserver.observe(navBarWrapper);
        }

        return () => {
            window.removeEventListener('resize', calculateSizing);
            navBarResizeObserver?.disconnect();
        };
    }, [calendarRef, isTopNavbarEnabled, timeSlots]);

    return { pixelsPerMinute };
};

export default useAdjustCalendarSize;